// components/CustomTypography.jsx
import React from "react";
import { Typography } from "@mui/material";

const SousTitreTypography = ({ children, sx = {} }) => {
  return (
    <Typography
      sx={{
        color: "#8F959E",
        fontFamily: "Montserrat, sans-serif",
        ...sx, // merge with custom styles passed as prop
      }}
    >
      {children}
    </Typography>
  );
};

export default SousTitreTypography;
